/**
  **@desc 这个文件是对web浏览器的本地存储做一些封装 方便在需要的时候用到
  **@author wcy
*/
export default {
  local: {
    has: function(key) {
      return localStorage.getItem(key) !== null
    },
    set: function(key, value) {
      localStorage.setItem(key, JSON.stringify(value))
      return true
    },
    get: function(key) {
      return JSON.parse(localStorage.getItem(key))
    },
    remove: function(key) {
      localStorage.removeItem(key)
      return true
    },
    clear: function() {
      localStorage.clear()
      return true
    }
  },
  session: {
    has: function(key) {
      return sessionStorage.getItem(key) !== null
    },
    set: function(key, value) {
      sessionStorage.setItem(key, JSON.stringify(value))
      return true
    },
    get: function(key) {
      return JSON.parse(sessionStorage.getItem(key))
    },
    remove: function(key) {
      sessionStorage.removeItem(key)
      return true
    },
    clear: function() {
      sessionStorage.clear()
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js